module.exports = __webpack_public_path__ + "img/check-circle-green.3fb6daca.svg";